import { getImpersonationUserId, getImpersonationView } from '../../stores/appImpersonationStore';
import { exitDemoSession, isDemoSession } from '../accountSetup/demoSession';

/** Context travels only with same-origin API calls; the Supabase login stays untouched. */
export function installImpersonationFetchInterceptor() {
  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const raw = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
    const url = new URL(raw, window.location.origin);
    if (url.origin !== window.location.origin || !url.pathname.startsWith('/api/')) return originalFetch(input, init);
    const headers = new Headers(init?.headers || (input instanceof Request ? input.headers : undefined));
    const demo = isDemoSession();
    const impersonationId = getImpersonationUserId();
    if (demo) {
      headers.set('X-Account-Demo', '1');
      headers.delete('X-Impersonate-User-Id');
      headers.delete('X-Impersonation-View');
    } else if (impersonationId) {
      headers.set('X-Impersonate-User-Id', impersonationId);
      headers.set('X-Impersonation-View', getImpersonationView());
    }
    const review = window.location.pathname.match(/^\/costprice\/automation-review\/([0-9a-f-]{36})(?:\/|$)/i);
    if (!demo && review) headers.set('X-Setup-Review-Run-Id', review[1]);
    const response = await originalFetch(input, { ...init, headers });
    if (response.status === 403) {
      const payload = await response.clone().json().catch(() => null);
      if (demo && payload?.code === 'demo_unavailable') exitDemoSession();
      if (!demo && payload?.code === 'account_setup_required' && !window.location.pathname.startsWith('/setup')) window.location.replace('/setup');
    }
    return response;
  };
}
